import React, { FC } from "react";
import { Dialog } from "react-toolbox/lib/dialog";
import { WidgetSnippetCode } from "components/AppChannels/components/WidgetSnippetCode";

interface UnifiedValue {
    id?: string;     //TODO: For the FormWidget value we currently use the id, since the schema does not have the key prop
    key?: string;
}

export interface SnippetDialogProps {
    readonly product: "search" | "widget" | "form";
    readonly active: boolean;
    readonly value: UnifiedValue;
    //readonly value: Pick<ChatWidgetAppChannel, "key">;
    onClose(): void;
}

export const SnippetDialog: FC<SnippetDialogProps> = ({ value, product, onClose, active }: SnippetDialogProps) => {

    return (
        <Dialog
            active={active}
            title={"Installation Snippet"}
            type={"large"}
            onEscKeyDown={onClose}
            onOverlayClick={onClose}
            actions={[{ label: "Done", onClick: onClose }]}
        >
            <WidgetSnippetCode product={product} title={false} snippetKey={'key' in value ? value.key : "???"} />
        </Dialog>
    );
};
